module.exports = __webpack_public_path__ + "static/media/toilet6.22ab94de.png";